<modal-form-container title="Edit contact" [showModal]="true" (closeModalEvent)="closeModal()">
  <form class="cf" [formGroup]="contactForm" (ngSubmit)="handleSubmit()" novalidate>
    <div class="cf__grid">
      <input-field
        label="First name"
        [errorMessage]="submitted && contactForm.controls.firstName.invalid ? 'Enter a first name' : ''"
      >
        <input class="input-style" formControlName="firstName" autocomplete="given-name" />
      </input-field>

      <input-field label="Last name">
        <input class="input-style" formControlName="lastName" autocomplete="family-name" />
      </input-field>

      <input-field class="cf__wide" label="Phone number" [errorMessage]="submitted ? phoneErrorMsg : ''">
        <ngx-mat-input-tel
          formControlName="primaryContactNumber"
          [enablePlaceholder]="true"
          [enableSearch]="true"
          (countryChanged)="countryChanged($event)"
          [preferredCountries]="preferredCountries"
        />
      </input-field>

      <input-field class="cf__wide" label="Email" [errorMessage]="submitted ? emailErrorMsg : ''">
        <input class="input-style" type="email" formControlName="emailAddress" autocomplete="email" />
      </input-field>

      <input-field label="Gender">
        <select name="gender" class="input-style" formControlName="gender">
          <option value="">Not set</option>
          <option value="MALE">Male</option>
          <option value="FEMALE">Female</option>
          <option value="OTHER">Other</option>
        </select>
      </input-field>

      <input-field label="Birth date">
        <input class="input-style" type="date" formControlName="birthDate" />
      </input-field>

      <input-field label="Country">
        <select name="country" class="input-style" formControlName="country">
          <option value="">Not set</option>
          @for (country of countries; track country) {
            <option [value]="country">{{ country }}</option>
          }
        </select>
      </input-field>

      <input-field label="City">
        <input class="input-style" formControlName="city" autocomplete="address-level2" />
      </input-field>

      <group-selection-input
        class="cf__wide"
        label="Organizations"
        (openSelectionEvent)="openAddOrganizationModal()"
        [selections]="selectedOrganizations"
        (removeSelectionEvent)="removeSelectedOrganization($event)"
      />
      <group-selection-input
        class="cf__wide"
        label="Tags"
        (openSelectionEvent)="openAddTagModal()"
        [selections]="selectedTags"
        (removeSelectionEvent)="removeSelectedTag($event)"
      />
    </div>

    @if (saveError) {
      <p class="cf__error" role="alert">
        <span class="bk-sym" aria-hidden="true">error</span>
        {{ saveError }}
      </p>
    }

    <div class="cf__foot">
      <customizable-button title="Cancel" type="button" [outline]="true" (click)="closeModal()" />
      <customizable-button title="Save changes" type="submit" [loading]="loading" />
    </div>
  </form>

  <!-- MODALS -->
  <assign-organizations-modal
    [open]="showAddOrganizationModal"
    (updateSelection)="updateSelectedOrganizations($event)"
    (close)="closeAddOrganizationModal()"
    [selection]="selectedOrganizations"
  />
  <assign-tags-modal
    [open]="showAddTagModal"
    (updateSelection)="updateSelectedTags($event)"
    (close)="closeAddTagModal()"
    [selection]="selectedTags"
  />
</modal-form-container>
